// extracted by mini-css-extract-plugin
export default {"page":"HM9AX","loading":"VurrF","header":"gvO3n","button":"midmK","inner":"Ix8pv","actionCell":"I2z0U","trashIcon":"qoqbE","emptyText":"dbZ7L","copyCell":"BhQ2L","copyLink":"stEoh"};